module.exports = __webpack_public_path__ + "static/media/transfer.b47c9be5.svg";